import api from '@/api/protect'
import bookingService from '@/api/booking'
import {PROTECT} from '@/store/types'

export default {
  state: {
    bookings: null,
    users: []
  },
  mutations: {
    [PROTECT.SET_BOOKINGS] (state, result) {
      state.bookings = []
      state.bookings = result
    },
    [PROTECT.PUSH_USER] (state, email) {
      state.users.push(email)
    },
    [PROTECT.REMOVE_USER] (state, index) {
      state.users.splice(index, 1)
    },
    [PROTECT.SET_USER] (state, user) {
      state.users = user
    }
  },
  namespaced: true,
  actions: {
    // eslint-disable-next-line no-empty-pattern
    protect ({}, data) {
      return api.protect(data.event, data.allRecurrenceEvents)
    },
    // eslint-disable-next-line no-empty-pattern
    unprotect ({}, data) {
      return api.unprotect(data.event, data.allRecurrenceEvents)
    },
    clearBookings ({ commit }) {
      commit(PROTECT.SET_BOOKINGS, [])
    },
    async findBooks ({dispatch, commit, rootGetters}, filter) {
      try {
        dispatch('Global/showLoading', null, {root: true})
        let respose = await bookingService.findBooks(filter.userEmail, filter.startDate, filter.endDate)

        for (var book of respose.data) {
          let rooms = []
          for (var room of book.rooms) {
            let roomDetails = Object.assign({}, rootGetters['Global/roomMap'][room.roomId])
            roomDetails.rejected = room.rejected
            rooms.push(roomDetails)
          }
          book.rooms = rooms
        }

        commit(PROTECT.SET_BOOKINGS, respose.data)
        dispatch('Global/hideLoading', null, {root: true})
      } catch (error) {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    pushUser ({ state, commit, dispatch }, item) {
      if (state.users.filter(user => user.email === item.email).length === 0) {
        commit(PROTECT.PUSH_USER, item)
      } else {
        dispatch('Global/showMessage', 'userDuplicated', {root: true})
      }
    },
    removeUser ({ commit }, index) {
      commit(PROTECT.REMOVE_USER, index)
    },
    setUsers ({ commit }, user) {
      commit(PROTECT.SET_USER, user)
    }
  }
}
